export const BILLING_TARIFF_SELECT_MODAL_NAME = 'billingTariffSelect';
